import { borderRadius, typographyV2 } from '@toggle/design-system';
import styled, { css } from 'styled-components';

export const CatalystInsightWrapper = styled.div<{
  $isClickable: boolean;
  $isCompanyCatalyst: boolean;
  $isRead: boolean;
}>`
  width: fit-content;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  gap: 4px;
  ${borderRadius.r2};
  background-color: ${({ $isCompanyCatalyst, $isRead }) =>
    $isRead
      ? 'var(--surface-default)'
      : $isCompanyCatalyst
      ? 'var(--surface-decorative-lime-default)'
      : 'var(--surface-decorative-cyan-default)'};
  ${({ $isClickable }) =>
    $isClickable &&
    css`
      &:hover {
        transform: scale(1.05);
        cursor: pointer !important;
      }
    `}
`;

export const CatalystInsightLabel = styled.span<{
  $isCompanyCatalyst: boolean;
  $isRead: boolean;
}>`
  ${typographyV2.uiXs};
  font-family: var(--font-nort);
  color: ${({ $isCompanyCatalyst, $isRead }) =>
    $isRead
      ? 'var(--text-soft)'
      : $isCompanyCatalyst
      ? 'var(--text-decorative-lime)'
      : 'var(--text-decorative-cyan)'};
`;
